import { PartnershipReferralResponse } from 'growth/usePartnershipReferrals';

/**
 * Returns a partnership where we want to show the buy tab but blocks them from having access to it
 */
export const getPartnershipBlockerModalType = (
  referral: PartnershipReferralResponse,
): 'homebuilder' | null => {
  if (referral.hasHomebuilderReferral) {
    return 'homebuilder';
  }

  return null;
};
